const theme_default = {
  id: 1,
  name: "default",
  displayName: "Default",
  themeBaseType: "dark",
  themeVariables: {
    COLORS: {
      ACCENT: "#26538D",
      SECONDARY: "#9CAFBF",
      SURFACE: "#191919",
      SURFACE_LIGHTER: "#282828",
      RECEIVE_BUBBLE: "#282828",
      BACKGROUND: "#121212",
      APP_BACKGROUND: "#121212",
      ON_ACCENT: "#FFFFFF",
      ON_SURFACE: "#FFFFFF",
      ON_BACKGROUND: "#FFFFFF",
    },
    BUTTON: {
      BORDER_RADIUS: "25px",
      SHADOW: "0 0 16px 0px rgba(0, 0, 0, 0.8)",
    },
    CONTAINER: {
      BORDER_RADIUS: "12px",
      SHADOW: "0px 0px 13px 1px rgba(0, 0, 0, 0.3)",
    },
    LIST: {
      BORDER_RADIUS: "15px",
    },
  },
};

export default theme_default;
